import { render, staticRenderFns } from "./BidRegisteredPopup.vue?vue&type=template&id=bb346c00&"
import script from "./BidRegisteredPopup.vue?vue&type=script&lang=js&"
export * from "./BidRegisteredPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports